import axios from "axios";

export const state = {
    patients: [],
};

export const getters = {
    patients: state => state.patients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.patients = newValue
    },
};

export const actions = {
    fetchPatients({ commit }) {
        axios.get('/patients').then(res => {
            commit('setPatients', res.data.patients)
        })
    },
};
